import axiosIns from "@/api/axios";

export const GET_ALL_DATA = (args) => {
  return axiosIns.get(`/vendor?${args}`);
};

export const GET_VENDOR_GROUP = () => {
  return axiosIns.get(`/vendors/vengroup`);
};

export const GET_ALL_DATA2 = (args) => {
  return axiosIns.get(`/vendors?${args}`);
};

export const ADD_DATA = (args) => {
  return axiosIns.post("/vendor/create", args);
};

export const SAVE_VENDOR_IDEATION = (args) => {
  return axiosIns.post(`/ideation/${args.id}/vendors`, args.bod);
};

export const UPDATE_DATA = (args) => {
  return axiosIns.put(`/vendor/update?id=${args.id}`, args.data);
};

export const EDIT_VENDOR_IDEATION = (args) => {
  // return axiosIns.put(`/ideation/${args.id}/vendors/id`, args.data);
  return axiosIns.put(`/ideation/${args.id}/vendors/${args.id_vendor}`, args.bod, {
    headers: {
        "Content-Type": "multipart/form-data"
    }
})
};

export const SEND_RFI_EMAIL = (args) => {
  // return axiosIns.put(`/ideation/${args.id}/vendors/id`, args.data);
  return axiosIns.post(`/ideation/${args.id_ideation}/vendors/${args.id_vendor}/rfi`, args.bod, {
    headers: {
        "Content-Type": "multipart/form-data"
    }
})
};

export const DELETE_DATA = (id) => {
  return axiosIns.delete(`/vendor/delete?id=${id}`);
};
